module.exports = __webpack_public_path__ + "media/images/spacer-cc9ffe52179905a0c5a8e2bfb8d5d3d4.gif";